import { memo, useCallback } from 'react';

import type { SymbolKey } from '@/entities/symbol';
import { isSameSymbol, isSameSymbolIgnoringPeriod } from '@/entities/symbol';
import { requestSpotSelection, SELECTOR_MODES } from '@/features/symbol-selector';
import CustomCheckbox from '@/shared/ui/primitives/Checkbox';
import { shallowEqual, useAppDispatch, useAppSelector } from '@/store/hooks';

const SymbolCheckboxComponent = ({
  symbol,
  disabled
}: {
  symbol: SymbolKey;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();

  const { isChecked, isSpotLocked } = useAppSelector(state => {
    const spotLocked = state.symbolSelector.selectorMode === SELECTOR_MODES.FORWARD_CURVE;
    const equals = spotLocked ? isSameSymbolIgnoringPeriod : isSameSymbol;
    return {
      isChecked: state.symbolSelector.symbols.some(s => equals(s, symbol)),
      isSpotLocked: spotLocked
    };
  }, shallowEqual);

  const handleChange = useCallback(() => {
    dispatch(requestSpotSelection({ symbol }));
  }, [dispatch, symbol]);

  return (
    <CustomCheckbox
      checked={isChecked}
      disabled={disabled}
      modeLocked={isSpotLocked}
      onLockedClick={handleChange}
      onChange={handleChange}
    />
  );
};

export const SymbolCheckbox = memo(SymbolCheckboxComponent);
